/**
 * Strip the Cognito Lambda-trigger wrapper from auth error messages.
 *
 * Cognito surfaces every PreSignUp / PreAuthentication / PreTokenGeneration
 * Lambda exception with a generic prefix like:
 *   "PreSignUp failed with error <our actual message>"
 *
 * We don't want users seeing that plumbing — they should see only the
 * friendly message our handlers throw. This helper strips the prefix and
 * returns the underlying message verbatim.
 *
 * Falls back to a generic "Request failed." if input is empty.
 *
 * @param {string|undefined|null} message raw error.message from aws-amplify
 * @returns {string} cleaned message
 */
export function formatAuthError(message) {
    if (!message) return 'Request failed.';
    return message.replace(
        /^Pre(SignUp|Authentication|TokenGen(eration)?)\s+failed with error\s+/i,
        ''
    );
}
